<template>
  <div>
    <Table
      ref="tablesMain"
      :data="insideTableData"
      :columns="insideColumns"
      :stripe="stripe"
      :border="border"
      :show-header="showHeader"
      :width="width"
      :loading="loading"
      :disabled-hover="disabledHover"
      :highlight-row="highlightRow"
      :row-class-name="rowClassName"
      :size="size"
      :no-data-text="noDataText"
      :no-filtered-data-text="noFilteredDataText"
      @on-current-change="onCurrentChange"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-select-all="onSelectAll"
      @on-selection-change="onSelectionChange"
      @on-sort-change="onSortChange"
      @on-filter-change="onFilterChange"
      @on-row-click="onRowClick"
      @on-row-dblclick="onRowDblclick"
      @on-expand="onExpand"
    >
      <slot name="header" slot="header"></slot>
      <slot name="footer" slot="footer"></slot>
      <slot name="loading" slot="loading"></slot>
    </Table>
    <Page :total="total" :page-size-opts="pageSizeOpts"
          show-elevator show-total show-sizer class="paging"
          @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
  </div>
</template>
<style scoped>
  .paging {
    text-align: right;
    margin-top: 10px;
    margin-right: 15px;
  }
</style>
<script>
import TablesEdit from './edit.vue'
import handleBtns from './handle-btns'
import './index.less'

export default {
  name: 'Tables',
  props: {
    value: {
      type: Object,
      default () {
        return {
          rows: [],
          total: 0
        }
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    size: String,
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    stripe: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightRow: {
      type: Boolean,
      default: true
    },
    rowClassName: {
      type: Function,
      default () {
        return ''
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String,
      default: '未找到对应的数据,请更改条件查询^^'
    },
    noFilteredDataText: {
      type: String
    },
    disabledHover: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    },
    /**
       * @description 全局设置是否可编辑
       */
    editable: {
      type: Boolean,
      default: false
    }
  },
  /**
     * Events
     * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
     * @on-cancel-edit 返回值 {Object} 同上
     * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
     */
  data () {
    return {
      insideColumns: [],
      insideTableData: [],
      edittingCellId: '',
      edittingText: '',
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 40, 100]
    }
  },
  methods: {
    supportEdit (item, index) {
      item.render = (h, params) => {
        return h(TablesEdit, {
          props: {
            params: params,
            value: this.insideTableData[params.index][params.column.key],
            edittingCellId: this.edittingCellId,
            editable: this.editable
          },
          on: {
            'input': val => {
              this.edittingText = val
            },
            'on-start-edit': (params) => {
              this.edittingCellId = `editting-${params.index}-${params.column.key}`
              this.$emit('on-start-edit', params)
            },
            'on-cancel-edit': (params) => {
              this.edittingCellId = ''
              this.$emit('on-cancel-edit', params)
            },
            'on-save-edit': (params) => {
              this.value[params.index][params.column.key] = this.edittingText
              this.$emit('input', this.value)
              this.$emit('on-save-edit', Object.assign(params, { value: this.edittingText }))
              this.edittingCellId = ''
            }
          }
        })
      }
      return item
    },
    supportHandle (item) {
      let options = item.options || []
      let insideBtns = []
      options.forEach(item => {
        if (handleBtns[item]) insideBtns.push(handleBtns[item])
      })
      let btns = item.button ? [].concat(insideBtns, item.button) : insideBtns
      item.render = (h, params) => {
        params.tableData = this.value
        return h('div', btns.map(item => item(h, params, this)))
      }
      return item
    },
    showCrtUser (item) {
      // 异步显示用户名称和时间
      item.render = (h, params) => {
        return h('div', [h('span', this.getUserName(params.row.crtUserId)),
          h('br'),
          h('span', params.row.crtTime)])
      }
      return item
    },
    showMdfUser (item) {
      // 异步显示用户名称和时间
      item.render = (h, params) => {
        return h('div', [h('span', this.getUserName(params.row.mdfUserId)),
          h('br'),
          h('span', params.row.mdfTime)])
      }
      return item
    },
    handleColumns (columns) {
      this.insideColumns = columns.map((item, index) => {
        let res = item
        if (res.editable) res = this.supportEdit(res, index)
        if (res.key === 'handle') res = this.supportHandle(res)
        if (res.key === 'crtUserId') res = this.showCrtUser(res)
        if (res.key === 'mdfUserId') res = this.showMdfUser(res)
        if (!res.minWidth) res.minWidth = 120
        if (res.dict) {
          res.render = (h, params) => {
            return h('span', this.getDictVal(res.dict, params.row[res.key]))
          }
        }
        return res
      })
    },
    handleClear (e) {
      if (e.target.value === '') this.insideTableData = this.value
    },
    handleTableData () {
      this.insideTableData = this.value.rows.map((item, index) => {
        let res = item
        res.initRowIndex = index
        return res
      })
      this.total = this.value.total
    },
    exportCsv (params) {
      this.$refs.tablesMain.exportCsv(params)
    },
    clearCurrentRow () {
      this.$refs.talbesMain.clearCurrentRow()
    },
    onCurrentChange (currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow)
    },
    onSelect (selection, row) {
      this.$emit('on-select', selection, row)
    },
    onSelectCancel (selection, row) {
      this.$emit('on-select-cancel', selection, row)
    },
    onSelectAll (selection) {
      this.$emit('on-select-all', selection)
    },
    onSelectionChange (selection) {
      this.$emit('on-selection-change', selection)
    },
    onSortChange (column, key, order) {
      this.$emit('on-sort-change', column, key, order)
    },
    onFilterChange (row) {
      this.$emit('on-filter-change', row)
    },
    onRowClick (row, index) {
      this.$emit('on-row-click', row, index)
    },
    onRowDblclick (row, index) {
      this.$emit('on-row-dblclick', row, index)
    },
    onExpand (row, status) {
      this.$emit('on-expand', row, status)
    },
    onPageChange (page) {
      this.page = page
      this.$emit('on-search', this.page, this.pageSize)
    },
    onPageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.onPageChange(1)
    }
  },
  watch: {
    columns (columns) {
      this.handleColumns(columns)
    },
    value (val) {
      this.handleTableData()
    }
  },
  mounted () {
    this.handleColumns(this.columns)
    this.handleTableData()
  }
}
</script>
